<template>
  <v-app id="inspire">
    <v-content class="content">
      <v-container
        fluid
      >
        <v-row
          align="start"
          justify="center"
          class="pa-0"
        >
          <v-col
            cols="10"
            sm="6"
            md="5"
            lg="4"
            xl="4"
            class="pa-0 mt-0"
          >
          <ErrorSnackbar :errorMessage="this.authErrors.errorMessage" :errorSnackbar.sync="errorSnackbar"/>
            <div class = "title-container">
              <v-list-item >
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class="headline mb-1">
                    <v-icon id="icon-style" size="2.4vh">fas fa-clouds</v-icon>
                  </v-list-item-title>
                  <v-list-item-subtitle class ="icon-subtitle">multicloud</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item >
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class ="login-title ma-0 pa-0">Verify</v-list-item-title>
                  <v-list-item-subtitle class="ma-0 pa-0">
                    <hr class="underscore">
                  </v-list-item-subtitle>
                  <p class="login-subtitle">PSC Multicloud Platform</p>
                </v-list-item-content>
              </v-list-item>
            </div>
            <v-form @submit.prevent="onVerify">
              <v-card class="elevation-0 pl-2 pr-2 pb-0 pt-0 ma-0" color="rgba(255, 0, 0, 0)">
                <v-card-text  class="justify-center pr-2 pl-2 pb-0 pt-0">
                    <v-text-field
                      class = "code-field"
                      label="Code"
                      name="code"
                      type="text"
                      rounded
                      solo
                      flat
                      height="50px"
                      v-model="code"
                      :error="errors && !$v.code.required"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-center mt-0 pt-0">
                  <v-btn 
                    class="text-none"
                    id="resend" 
                    rounded
                    min-height="50px"
                    height="50px"
                    max-height="50px"
                    @click="resendCode">
                    Resend code
                    </v-btn>
                  <v-btn 
                    type="submit" 
                    class="text-none"
                    rounded
                    id="verify"
                    min-height="50px"
                    height="50px"
                    max-height="50px"
                    :disabled="errors || !$v.code.required"
                  >
                    <v-icon id="spinner" medium center v-if="loading">fas fa-spinner fa-spin</v-icon>
                    <span v-else>Verify</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import ErrorSnackbar from "./ErrorSnackbar";

import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      code: "",
      errors: false,
      errorSnackbar: false,
      loading: false
    };
  },
  mixins: [validationMixin],
  validations: {
    code: { required }
  },
  computed: mapGetters([
    "cognitoInfo",
    "loggedIn",
    "credentials",
    "verified",
    "authErrors"
  ]),
  methods: {
    ...mapActions(["verify", "resendConfirmationCode"]),
    async onVerify() {
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.loading = true;
        const data = {
          username: this.credentials.username,
          password: this.credentials.password,
          code: this.code.trim()
        };
        await this.verify(data);

        if (this.authErrors.isError) this.errorSnackbar = true;

        if (this.loggedIn) {
          this.$router.push("/environments");
        }
        this.loading = false;
      }
    },
    async resendCode() {
      await this.resendConfirmationCode(this.credentials.username);
    }
  },
  created() {
    if (this.verified) {
      this.$router.push("/signup");
    }
  },
  components: {
    ErrorSnackbar
  }
};
</script>

<style scoped>
.content {
  background-image: url("../../assets/casestudies-banner.png");
  background-size: cover;
}

.code-field .v-input__slot {
  background-color: #ffffff;
}

#verify {
  background-color: #6db42c;
  color: #ffffff !important;
  width: 50%;
  height: 5vh !important;
  font: 1.2rem "Montserrat";
  border-radius: 12vw;
}

#verify:focus::before {
  opacity: 0 !important;
}

#resend {
  background-color: #881e98 !important;
  color: #ffffff !important;
  width: 50%;
  height: 5vh !important;
  font: 1.2rem "Montserrat";
  border-radius: 12vw;
}

#resend:focus::before {
  opacity: 0 !important;
}

.title-container {
  text-align: center;
  margin-bottom: 8vh;
  margin-top: 2vh!important;
}

#icon-style {
  color: #ffffff !important;
  margin-top: 0.3vh!important;
}

.icon-subtitle {
  color: #ffffff !important;
  margin-bottom: 8vh;
  font: bold 1rem "Montserrat";
}

.login-title {
  color: #ffffff !important;
  font: Bold 2.3rem "Montserrat";
}

.login-subtitle {
  color: #ffffff !important;
  font: 1rem "Montserrat";
}

.underscore {
  background-color: #6db42c;
  border: 0.2vh solid #6db42c;
  border-radius: 0.2vh;
  width: 3vw;
  margin: auto;
  margin-top: 1.6vh;
  margin-bottom: 3vh;
}

#spinner {
  color: white!important;
}

.code-field >>> .v-input__control {
  min-height: auto !important;
  border-radius: 12vw!important;
  margin-bottom: 3%;
  font: 1rem "Montserrat";
}
</style>
